import styled from 'styled-components';
import { Input } from 'components';
import {
  ChevronDown,
  ChevronUp,
  CircleX,
  Filter as FilterIcon,
  Search as SearchIcon,
} from 'lucide-react';

export const FilterContainer = styled.div.attrs({
  className: 'flex flex-row items-center justify-between mb-4 gap-2',
})`
  z-index: 20;
`;

export const SearchContainer = styled.div.attrs({
  className: 'relative flex-1',
})``;

export const SearchIconWrapper = styled.div.attrs({
  className: 'absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground',
})``;

export const ControlsContainer = styled.div.attrs({
  className: 'flex flex-row items-center justify-between mb-4',
})`
  z-index: 10;
`;

export const EntryCount = styled.div.attrs({
  className: 'text-sm text-muted-foreground flex items-center gap-1 font-medium',
})``;

export const StatusBadge = styled.button.attrs({
  type: 'button',
  className:
    'flex items-center gap-1 px-1.5 py-0.5 rounded-md text-xs font-bold cursor-pointer hover:opacity-80 transition-opacity ml-1',
})``;

export const FailedBadge = styled(StatusBadge).attrs({
  className: 'bg-red-50 text-red-600 border border-red-100',
})``;

export const NotExportedBadge = styled(StatusBadge).attrs({
  className: 'bg-slate-50 text-slate-600 border border-slate-200',
})``;

export const ActionButtons = styled.div.attrs({
  className: 'flex flex-row items-center gap-4',
})``;

export const ActionButton = styled.button.attrs({
  className:
    'flex items-center gap-1 text-sm font-medium text-ring-light hover:opacity-80 transition-opacity whitespace-nowrap',
})``;

export const FilterActiveCount = styled.span.attrs({
  className:
    'flex items-center justify-center bg-primary text-white rounded-full w-5 h-5 text-[10px] font-bold',
})``;

export const FilterRow = styled.div.attrs({
  className: 'flex flex-row items-center gap-1 w-full mb-4',
})`
  z-index: 5;
`;

export const ClearFiltersButton = styled.button.attrs({
  className: 'ml-auto p-1.5 text-slate-400 hover:text-slate-600 transition-colors',
})``;

export const XIconStyled = styled(CircleX).attrs({
  className: 'h-4 w-4 text-ring-light',
})``;

export const SearchIconStyled = styled(SearchIcon).attrs({
  className: 'h-4 w-4',
})``;

export const SearchInput = styled(Input).attrs({
  className: 'pl-9 h-10 py-2 text-sm bg-white',
})``;

export const FilterIconStyled = styled(FilterIcon).attrs({
  className: 'h-4 w-4',
})``;

export const ChevronDownIcon = styled(ChevronDown).attrs({
  className: 'h-4 w-4 opacity-50',
})``;

export const ChevronUpIcon = styled(ChevronUp).attrs({
  className: 'h-4 w-4 opacity-50',
})``;
